import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../../../../locale";
import ToggleField from "../components/ToggleField";

function ProductFormFooter({ form }) {
  return (
    <div className="flex flex-column gap-4 mt-3">
      <div className="flex flex-wrap product-form-notify">
        <div className="flex flex-column gap-3" style={{ minWidth: "240px" }}>
          <ToggleField
            title={localeText("notifyAllUsers")}
            checked={form.notifyAllUsers}
            onChange={form.setNotifyAllUsers}
            footer={true}
          />
          <ToggleField
            title={localeText("notifyMyEconomicCircle")}
            checked={form.notifyMyEconomicCircle}
            onChange={form.setNotifyMyEconomicCircle}
            footer={true}
          />
        </div>
      </div>
      <div className="flex justify-content-end product-form-footer-button">
        <Button
          label={localeText(form.isEdit ? "save" : "register")}
          onClick={form.handleSubmit}
          loading={form.saving}
          disabled={form.saving}
          className="border-none border-round-lg"
          style={{ backgroundColor: "var(--theme-secondary)", minWidth: "160px" }}
        />
      </div>
    </div>
  );
}

export default ProductFormFooter;
